__turbopack_context__.v({
  "imageSliderBlock": "imageSliderBlock-module-scss-module__JU0Acq__imageSliderBlock",
});
